import HostInfo from "./HostInfo";
import "./index.css";
export default HostInfo;